import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material"
import { keyframes } from "@emotion/react";
import moment from "moment";

const shine = keyframes`
    0% { left: -75%; }
    100% { left: 125%; }
`;

export const Modals = ({open, setOpen, bibleVerse}) => {
    
    const handleClickAmen = () => {
        localStorage.setItem('bible_toggle_session', JSON.stringify({tool_id:process.env.REACT_APP_TID_BIZ, date:moment().format('YYYY-MM-DD'), toggle:false }))
        setOpen(false)
    }

    return (
        <Dialog
            fullWidth={true}
            open={open}
        >
            <DialogContent 
                sx={{
                    width:"100%",
                    height:'100%',
                    position: "relative",
                    borderRadius: 2,
                    overflowY: "scroll",
                    overflowX: "hidden",
                    cursor: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ctext y='24' font-size='24'%3E🙏%3C/text%3E%3C/svg%3E") 16 16, auto`,
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: "-75%",
                        width: "50%",
                        height: "100%",
                        background:
                        "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
                        transform: "skewX(-20deg)",
                        animation: `${shine} 2.5s infinite`,
                    },
                }}
            >
                <Box width="100%" minHeight="84px" display="flex" flexDirection="column" gap="16px">
                    <Box width="100%" display="flex" flexDirection="column" gap="16px" px="24px">
                        <Box width="100%" minHeight="48px" display="flex" alignItems="center" gap="4px">
                            <Typography color="#283745" fontSize={24} fontWeight={700} textAlign="center">
                                My Guiding Word {bibleVerse.stat !== 'default' && 'Today'}:
                            </Typography>
                        </Box>
                        <Box height="100%" display="flex" flexDirection="column">
                            <Typography color="#283745" fontSize={20} fontWeight={400}>
                            "{bibleVerse.verses}"
                            </Typography>
                        </Box>
                        <Box minHeight="48px" display="flex" alignItems="center">
                            <Typography color="#283745" fontSize={14} fontWeight={700} pr={1}>
                            {bibleVerse.bookname}
                            </Typography>
                            <Typography color="#283745" fontSize={14} fontWeight={600}>
                            {bibleVerse.chapter}:
                            </Typography>
                            <Typography color="#283745" fontSize={14} fontWeight={600}>
                            {bibleVerse.verse_no}
                            </Typography>
                        </Box>
                        <Box width="100%" minHeight="72px" display="flex" justifyContent="center" alignItems="center" gap="16px" px="24px"
                        >
                            <Button  
                                onClick={handleClickAmen}
                                fullWidth
                                sx={{
                                    borderRadius:'6px',
                                    width:'100%', 
                                    height:'36px', 
                                    bgcolor:'#003022', 
                                    color:'#FFFFFF',
                                    cursor: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ctext y='24' font-size='24'%3E🙏%3C/text%3E%3C/svg%3E") 16 16, auto`,
                                    ':hover':{bgcolor:"#000000"},
                                    ':disabled':{bgcolor:"#4d4b4bff", color:"#d4c6c6ff"},
                                }}
                            >
                                Amen    
                            </Button>
                        </Box>
                    </Box>
                </Box>
           
            </DialogContent>
           
        </Dialog>
    )
}